"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimmedPhone = exports.title = exports.teamName = exports.phoneNumeric = exports.phoneLength = exports.phone = exports.passwordSymbols = exports.passwordNumbers = exports.passwordLength = exports.passwordCase = exports.password = exports.nameLength = exports.name = exports.isUrl = exports.heardAbout = exports.forbiddenXSSCharacters = exports.email = exports.description = exports.confirmPassword = void 0;
var _validator = _interopRequireDefault(require("validator"));
var Joi = require('joi');
var _require = require('@hapi/tlds'),
  tlds = _require.tlds;
var allowedEmailDomains = tlds.add('mail');
var emailValidationSchema = Joi.string().email({
  tlds: {
    allow: allowedEmailDomains
  }
});
function validateEmail(email) {
  var valid = emailValidationSchema.validate(email);
  return !valid.error;
}
var passwordLength = exports.passwordLength = function passwordLength(v) {
  return _validator["default"].isLength(v, 12, 32);
};
var passwordCase = exports.passwordCase = function passwordCase(v) {
  return /[a-z]/.test(v) && /[A-Z]/.test(v);
};
var passwordSymbols = exports.passwordSymbols = function passwordSymbols(v) {
  return /[~`!@#$%^&*()\-_=+[{\]}\\|;:'",<.>/?]/g.test(v);
};
var passwordNumbers = exports.passwordNumbers = function passwordNumbers(v) {
  return /\d/.test(v);
};
var confirmPassword = exports.confirmPassword = function confirmPassword(password1, password2) {
  return password1 === password2;
};
var password = exports.password = function password(v) {
  return passwordLength(v) && passwordCase(v) && passwordSymbols(v) && passwordNumbers(v);
};
var title = exports.title = function title(v) {
  return v.length >= 2 && v.length <= 64;
};
var description = exports.description = function description(v) {
  return v.length >= 2 && v.length <= 200;
};
var name = exports.name = function name(v) {
  return v.length > 1 && v.length <= 64;
};
var nameLength = exports.nameLength = function nameLength(v) {
  return _validator["default"].isLength(v, 2, 50);
};
var teamName = exports.teamName = function teamName(v) {
  return v.length > 1 && v.length <= 32;
};
var heardAbout = exports.heardAbout = function heardAbout(v) {
  return v.length > 1 && v.length <= 300;
};
var email = exports.email = function email(v) {
  return validateEmail(v);
};
var trimmedPhone = exports.trimmedPhone = function trimmedPhone(v) {
  return v.replace(/[-+)(\s]/g, '');
};
var phoneNumeric = exports.phoneNumeric = function phoneNumeric(v) {
  return _validator["default"].isNumeric(v);
};
var phoneLength = exports.phoneLength = function phoneLength(v) {
  return v.length >= 4 && v.length <= 15;
};
var phone = exports.phone = function phone(v) {
  var number = trimmedPhone(v);
  return phoneNumeric(number) && phoneLength(number);
};
var forbiddenXSSCharacters = exports.forbiddenXSSCharacters = function forbiddenXSSCharacters(v) {
  return !/[$<>;]/.test(v);
};
var isUrl = exports.isUrl = function isUrl(v) {
  return _validator["default"].isURL(v);
};